import React, { useEffect, useState } from "react";

const SelectBySkillModel = (props) => {
    const { onSelectedModel, modelsData, selectedSkill } = props;

    const [selectedValue, setSelectedValue] = useState("");

    useEffect(() => {
        if (modelsData?.length > 0) {
            const defaultModel = modelsData[0];
            setSelectedValue(defaultModel.Id);
            onSelectedModel(defaultModel.Id, defaultModel.Name);
        }
    }, [selectedSkill, modelsData]); 

    const selectByModelHandler = (e) => {
        const selectedVal = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;

        setSelectedValue(selectedVal);
        onSelectedModel(selectedVal, text);
    };

    return (
        <div className="model-dropdown">
            <select
                title="Select Model"
                className="skill-filter-field w-select"
                value={selectedValue}  
                onChange={selectByModelHandler}
            >
                {modelsData?.map((item) => (
                    <option key={item.Id} value={item.Id}>
                        {item.Name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SelectBySkillModel;